import React, { useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import AccordionButton from "../Accordion/AccordionButton"

const RecipesFAQ = ({ 
  product,
  properties = {
    background: "bg-dorot-health-facts rounded-lg",
    title: "text-dorot-purple 1024:font-bold font-semibold",
    content: "text-dorot-purple",
    padding: "px-4 py-6",
  },
  openProperties = {
    background: "bg-dorot-health-facts rounded-lg",
    title: "text-dorot-purple 1024:font-bold font-semibold",
    content: "text-dorot-purple",
    padding: "px-4 py-6",
  },
  iconProperties = {
    css: "text-dorot-purple text-_2432 font-bold",
    icon: "+",
  },
  iconOpenProperties = {
    css: "text-dorot-purple text-_2432 font-bold",
    icon: "-",
  },
  hidePatterns = false,
}) => {

  const image = useStaticQuery(graphql`
    {
      pattern: file(relativePath: { eq: "product_pattern.webp" }) {
        childImageSharp {
          gatsbyImageData(
            formats: WEBP
            width: 573
            height: 443
            placeholder: BLURRED
            quality: 85
          )
        }
      }
      patternFull: file(relativePath: { eq: "product_pattern_full.webp" }) {
        childImageSharp {
          gatsbyImageData(
            formats: WEBP
            width: 1920
            height: 526
            placeholder: BLURRED
            quality: 85
          )
        }
      }
    }`
  )

  const pattern = getImage(image.pattern)
  const patternFull = getImage(image.patternFull)

  const [accordionKey, setAccordionKey] = useState(null)

  const handleToggle = id => {
    setAccordionKey(accordionKey !== id ? id : null)
  }


  return (
    <div className='relative px-7.5 1024:px-0'>
      {!hidePatterns && (
        <>
          <GatsbyImage
            image={patternFull}
            alt='pattern background'
            style={{ position: "absolute" }}
            className="bottom-0 right-0 !hidden 1024:!block 1024:top-0 z-0"
          />
          <GatsbyImage
            image={pattern}
            alt='pattern background'
            style={{ position: "absolute" }}
            className="bottom-0 right-0 1024:!hidden z-0"
          />
        </>
      )}
      <div className="relative flex flex-col justify-center items-center z-10 gap-y-10">
        <div className='flex flex-col space-y-4 min-h-[353px] 1024:min-h-0 w-full 1024:space-y-3.5 1024:justify-center lg:space-y-8'>
          <h3 className='text-dorot-purple font-gelica text-center font-bold text-_2628 lg:text-_3642'>{product.faqsTitle}</h3>
          {product?.faq?.map((item, index) => (
            <AccordionButton
              id={index}
              isFirst={index === 0}
              title={item.question}
              content={item.answer}
              handleToggle={() => handleToggle(index)}
              isOpen={accordionKey === index}
              key={index}
              properties={properties}
              openProperties={openProperties}
              iconProperties={iconProperties}
              iconOpenProperties={iconOpenProperties}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default RecipesFAQ